import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { S1Modal, S1ButtonType, S1UIService, S1ModalSizes } from '@app/s1';
import { IPista } from '@app/shared/models/pista';
import { PistaService } from '@app/shared/services/pista.service';

@Component({
  selector: 'ser-pista',
  templateUrl: './pista.component.html',
  styleUrl: './pista.component.scss'
})
export class PistaComponent {

  @Output() updated = new EventEmitter<boolean>();
  @Output() created = new EventEmitter<string>();

  @ViewChild('modal') modal: S1Modal;

  s1ButtonType = S1ButtonType;

  pistaForm: UntypedFormGroup;
  pista: IPista;
  isNew: boolean = true;
  idStazione: string;

  constructor(private formBuilder: UntypedFormBuilder, private pistaService: PistaService, private ui: S1UIService) {

    this.pistaForm = this.formBuilder.group({
      'codice': [Validators.required, null],
      'descrizione': [Validators.required, null],
      'tipoPista': [null, null]
    })

  }

  ngOnInit(): void {

  }

  open(idStazione: string, pista?: IPista) {

    this.idStazione = idStazione;
    this.pista = pista;
    this.isNew = !this.pista;

    this.pistaService.idPath = this.idStazione;
    this.pistaForm.reset();

    this.pistaForm.patchValue({
      'codice': this.pista?.codice,
      'descrizione': this.pista?.descrizione,
      'tipoPista': this.pista?.idTipoPista
    })

    this.modal.open(S1ModalSizes.MD);

  }

  close() {
    this.modal.close();
  }

  create() {

    const newPista: IPista = {
      "codice": this.pistaForm.controls.codice.value,
      "descrizione": this.pistaForm.controls.descrizione.value,
      "idTipoPista": this.pistaForm.controls.tipoPista.value
    }

    this.pistaService.crea(newPista).subscribe(pista => {
      this.ui.showSuccessToast("piste.messages.created");
      this.close();
      this.created.emit(pista);
      this.pistaForm.reset();
    })

  }

  update() {

    const pistaToUpdate: IPista = {
      "id": this.pista.id,
      "codice": this.pistaForm.controls.codice.value,
      "descrizione": this.pistaForm.controls.descrizione.value,
      "idTipoPista": this.pistaForm.controls.tipoPista.value
    }

    this.pistaService.modifica(pistaToUpdate).subscribe(success => {

      if (success) {
        this.ui.showSuccessToast("piste.messages.updated");
        this.updated.emit(success);
        this.pistaForm.reset();
        this.close();
      }
      
    })

  }

}
